// NOTE: Sentry should be initialized as early as possible in the app's lifecycle
import { Buffer } from 'buffer'
import './sentry'

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer
}
import { StrictMode } from 'react'
import { ApolloProvider } from '@apollo/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from 'app/app'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { apolloClient } from './apollo-client'
import { AuthProvider } from './auth-provider'
import { SolanaProviders } from './solana-providers'
import { SolanaWalletStateProvider } from 'shared/contexts/solana-wallet-state-provider'

const container = document.querySelector('#root')
if (container) {
  const root = createRoot(container)
  const queryClient = new QueryClient()

  root.render(
    <StrictMode>
      <ApolloProvider client={apolloClient}>
        <SolanaProviders>
          <SolanaWalletStateProvider>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </QueryClientProvider>
          </SolanaWalletStateProvider>
        </SolanaProviders>
      </ApolloProvider>
    </StrictMode>
  )
}
